import { ContentContainer } from '@/shared/layouts/ContentContainer';
import { ExpenseLedgerWidget } from '@/features/dashboard/widgets/accounts/ExpenseLedgerWidget';

export function LedgerPage() {
  return (
    <ContentContainer title="Expense Ledger">
      <ExpenseLedgerWidget />
    </ContentContainer>
  );
}
